import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { useForm } from "react-hook-form";
import { Base } from "components/template";
import { ProgressBar } from "components/molecules";
import { InputControl, SelectControl } from "components/organism";
import { yupResolver } from "@hookform/resolvers/yup";
import { Button } from "components/atoms";
import { complementaryDataSchema } from "_config/formSchemas";
import { complementaryData } from "_config/store/onBoarding/onBoarding.thunk";
import { useLocalStorage, useOnBoarding } from "_hooks";

const prefix = "v-complementary-data";

const ComplementaryData = () => {

  const dispatch = useDispatch();
  const { register, handleSubmit, formState: { errors }, watch } = useForm({
    resolver: yupResolver(complementaryDataSchema)
  });
  
  const [onBoarding, setOnBoarding] = useLocalStorage("onBoarding");
  const { state } = useLocation();
  const navigate = useNavigate();

  const { mediaList } = useOnBoarding();
  const { data: response, isLoading } = useSelector((s) => s.onBoarding.complementaryData);

  const { mediaName } = watch();

  const onSubmit = async(data) => {
    await dispatch(complementaryData(onBoarding?._id, {
      ...data,
      ...state?.searchParams || {}
    }));
  };

  useEffect(() => {
    if (response !== null) {
      setOnBoarding(response);
      setTimeout(() => navigate("/account/create", { state }), 100);
    }
  }, [response]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <Base
      align="normal"
      header={<ProgressBar max={7} progress={6} />}
      headerClass={"mx-auto w-full sm:w-2/3 md:w-3/5 lg:w-4/12 max-w-[550px] mt-10 mb-0"}
    >
      <div className={`${prefix} flex flex-wrap flex-col p-3 mx-auto w-full sm:w-2/3 md:w-3/5 lg:w-4/12 max-w-[550px]`}>
        <div className="flex flex-wrap flex-col gap-3 ">
          <p className="text-center text-3xl font-bold mx-auto">Por último</p>
          <p className="text-center text-xl mx-auto mb-10">Ya casi tienes tu cuenta</p>

          <form
            className="flex flex-wrap gap-7" 
            onSubmit={handleSubmit(onSubmit)}
          >
            <SelectControl
              errors={errors?.mediaName}
              selectProps={{
                emptyLabel: "Selecciona una opción",
                value: mediaName,
                ...register("mediaName")
              }}
              label="¿Cómo te enteraste de Nubesk?"
              name="mediaName"
              orientation="vertical"
              options={mediaList?.map((m) => ({
                label: m.title,
                value: m.key
              }))}
            />

            <InputControl
              errors={errors?.referralCode}
              label="¿Tienes un código de referido?"
              orientation="vertical"
              inputProps={{
                autoComplete: "off",
                placeholder: "Ingresa el código",
                ...register("referralCode")}
              }
            />

            <Button
              className="bg-primary text-white rounded-lg mt-5"
              disabled={isLoading}
              fullwidth
              pulse
              spin={isLoading}
            >Crear mi cuenta</Button>
          </form>
        </div>
      </div>
    </Base>
  );
};

export default ComplementaryData;
